import { serverConfig } from '@/config/server';
import type { Source } from '@/types';

class SourceService {
  private readonly baseUrl: string;

  public constructor() {
    this.baseUrl = serverConfig.baseUrl;
  }

  public async fetchSources(): Promise<readonly Source[]> {
    const response = await fetch(`${this.baseUrl}/sources`);

    if (!response.ok) {
      throw new Error(`Failed to fetch sources: ${response.statusText}`);
    }

    const data = await response.json();
    return Array.isArray(data) ? data : data.sources || [];
  }
}

export const sourceService = new SourceService();
